import BuildArea from '../BuildArea'
import Application from '../../../layout/Application'
import { IndicatorDetailView } from '../indicatorBuilder'
import { Pattern, PatternProvider, usePatternContext } from '../contexts/PatternContext'
import PatternDetailView from '../components/PatternDetailView'
import Box from '@mui/material/Box'
import { AlertProvider } from '../../alerts/contexts/AlertContext'
import { Tabs } from '../../../layout/MainLayout'
import BacktestEdit from '../../../components/backtests/BacktestEdit'
import { useEffect } from 'react'
import { useApplicationSuiteContext } from '../../../contexts/ApplicationSuiteProvider'

function PatternBuilderApp() {
  const { activeTab, setActiveTab } = useApplicationSuiteContext()

  const {
    backtestToView,
    setBacktestToView,
    editingPattern,
    setEditingPattern,
    editingPatternIsTradingHouse,
    setEditingPatternIsTradingHouse,
    editingIndicator,
    patterns,
    tradingHousePatterns,
  } = usePatternContext()

  // Handle deep-linking: when navigating to pattern builder with a specific pattern
  useEffect(() => {
    const pattern = activeTab.options?.item as Pattern
    if (activeTab.tab === Tabs.PatternBuilder && pattern) {
      // If the user owns this pattern, use the live Firestore version
      // instead of the stale snapshot (e.g. from an alert)
      const livePattern = pattern.id ? patterns?.find((p: any) => p.id === pattern.id) : null
      const patternToEdit = livePattern || pattern
      setEditingPattern(patternToEdit)
      const isTradingHouse = patternToEdit.id
        ? !!(tradingHousePatterns as any[])?.some((p: any) => p.id === patternToEdit.id)
        : false
      setEditingPatternIsTradingHouse(isTradingHouse)
      delete activeTab.options!.item
      setActiveTab({ tab: Tabs.PatternBuilder, options: activeTab.options })
    }
  }, [
    setEditingPattern,
    setEditingPatternIsTradingHouse,
    setActiveTab,
    activeTab,
    patterns,
    tradingHousePatterns,
  ])

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        overflow: 'auto',
        position: 'relative',
        display: 'flex',
      }}
    >
      {backtestToView ? (
        <BacktestEdit backtestToView={backtestToView} goBack={() => setBacktestToView(null)} />
      ) : editingPattern ? (
        <PatternDetailView
          pattern={editingPattern}
          onBack={() => setEditingPattern(null)}
          isTradingHousePattern={editingPatternIsTradingHouse}
        />
      ) : editingIndicator ? (
        <IndicatorDetailView />
      ) : (
        <Box sx={{ flexGrow: 1 }}>
          <BuildArea />
        </Box>
      )}
    </Box>
  )
}

const AlertProviderWrapper = ({ children }: any) => {
  return (
    <AlertProvider isNested parentTab={Tabs.PatternBuilder}>
      {children}
    </AlertProvider>
  )
}

const App = ({ tab }: any) => (
  <Application
    AppComponent={PatternBuilderApp}
    ContextProviders={[PatternProvider, AlertProviderWrapper]}
    tab={tab}
  />
)
export default App
